import axios from "axios";
console.log("DEBUG API_FILE:", process.env.REACT_APP_API_FILE);
console.log("DEBUG API_MASTER:", process.env.REACT_APP_API_MASTER);
const API_FILE = axios.create({
  baseURL: process.env.REACT_APP_API_FILE,
});

const API = axios.create({
  baseURL: process.env.REACT_APP_API_MASTER,
  headers: {
    "Content-Type": "application/json"
  }
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
    });

class LabUjiService {
    
    createLabUji(jsondata) {
        return API.post("/labuji/lab-uji/", jsondata);
    }

    getAllLabUji(params = {}) {
        const page = params.page || 1;
        const perPage = params.limit || params.per_page || 10;
        return API.get(`/labuji/lab-uji/?page=${page}&per_page=${perPage}&limit=${perPage}`);
    }

    getLabUji(params = {}) {
        const page = params.page || 1;
        const perPage = params.limit || params.per_page || 10;
        return API.get(`/labuji/lab-uji/?page=${page}&per_page=${perPage}&limit=${perPage}`);
    }
    getJenisUji() {
        return API.get("/data/jenis-uji/");
    }
    postFileUpload(formData) {
    return API_FILE.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
export default new LabUjiService();